// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"311":"7ee9a061","725":"3b4acb46","767":"e292bca0","931":"3d2f288b"}[chunkId] + ".css";
};